import React, { Component } from "react";
import { withRouter } from "react-router-dom";


class PrivacyPolicy extends Component {
  constructor() {
    super();
    this.state = {
    };
  }
  render() {

    return (
             <div className="Terms">
             <div className="TermsHead">
                 <h2>PRIVACY POLICY</h2>
                 </div>
                 <div>Last updated: 24/01/2024</div>
                 <h3>1.	Introduction</h3>
                 <p>Welcome to <b>WHAT TO FABRIKAT OÜ</b>.
 
 <br></br><br></br>WHAT TO FABRIKAT OÜ (“us”, “we”, or “our”) operates https://lendstack.app and Lendstack mobile application (hereinafter referred to as “<b>Service</b>”).
  
 <br></br><br></br>Our Privacy Policy governs your visit to https://lendstack.app and Lendstack mobile application, and explains how we collect, safeguard and disclose information that results from your use of our Service. 
  
 <br></br><br></br>We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
  
 <br></br><br></br>Our Terms and Conditions (“<b>Terms</b>”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“<b>agreement</b>”).
 </p><br></br>
 <h3>2.	Definitions</h3>
 <p><b>SERVICE</b> means the https://lendstack.app website and Lendstack mobile application operated by WHAT TO FABRIKAT OÜ.
 
 <br></br><br></br><b>PERSONAL DATA</b> means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).
  
 <br></br><br></br><b>USAGE DATA</b> is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).
  
 <br></br><br></br><b>COOKIES</b> are small files stored on your device (computer or mobile device).
  
 <br></br><br></br><b>DATA CONTROLLER</b> means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.
  
 <br></br><br></br><b>DATA PROCESSORS (OR SERVICE PROVIDERS)</b> means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.
  
 <br></br><br></br><b>DATA SUBJECT</b> is any living individual who is the subject of Personal Data.
  
 <br></br><br></br><b>THE USER</b> is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.
 </p><br></br>
 <h3>3.	Information Collection and Use</h3>
 <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p><br></br>
             <h3>4.	Types of Data Collected</h3>
             <h4>Personal Data</h4>
             <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“<b>Personal Data</b>”). Personally identifiable information may include, but is not limited to:
 
 <br></br><br></br>(a)	Email address
  
 <br></br><br></br>(b)	First name and last name
  
<br></br><br></br> (c)	Phone number
  
 <br></br><br></br>(d)	Address, State, Province, ZIP/Postal code, City
  
 <br></br><br></br>(e)	Cookies and Usage Data
  
 <br></br><br></br>We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at cofounder@lendstack.app.
 </p><br></br>
 <h4>Usage Data</h4>
 <p>We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through a mobile device (“<b>Usage Data</b>”).
 
 <br></br><br></br>This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
  
 <br></br><br></br>When you access Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
 </p><br></br>
 <h4>Location Data</h4>
 <p>We may use and store information about your location if you give us permission to do so (“<b>Location Data</b>”). We use this data to provide features of our Service, to improve and customize our Service.
 
 <br></br><br></br>You can enable or disable location services when you use our Service at any time by way of your device settings.
 </p><br></br>
 <h4>Contact List</h4>
 <p>We may request access to your device's contact list to facilitate social sharing, messaging, etc. The contact list is used solely for facilitating social connections within the app. We do not store or share this information without your explicit consent.
 
  </p><br></br>
  <h4>Images</h4>
 <p>We may access and use images stored on your device for in-app customization and also to know your customer (kyc) compliance. Images accessed by LendStack App are used exclusively for in-app features. We do not transfer or use these images for any other purposes without your explicit permission
 
  </p><br></br>


 <h4>Tracking Cookies Data</h4>
 <p>We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.
 
<br></br><br></br> Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyze our Service.
  
 <br></br><br></br>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
  
 <br></br><br></br>Examples of Cookies we use:
  
 <br></br><br></br>(a)	<b>Session Cookies:</b> We use Session Cookies to operate our Service.
  
 <br></br><br></br>(b)	<b>Preference Cookies:</b> We use Preference Cookies to remember your preferences and various settings.
  
 <br></br><br></br>(c)	<b>Security Cookies:</b> We use Security Cookies for security purposes.
  
 <br></br><br></br>(d)	<b>Advertising Cookies:</b> Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.
 </p><br></br>
 <h4>Other Data</h4>
 <p>While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, registration at place of residence and actual address, telephone number (work, mobile), details of documents on education, qualification, professional training, employment agreements, non-disclosure agreements, information on bonuses and compensation, information on marital status, family members, social security (or other taxpayer identification) number, office location and other data. </p><br></br>
             <h3>5.	Use of Data</h3>
             <p>WHAT TO FABRIKAT OÜ uses the collected data for various purposes:
 
 <br></br><br></br>(a)	to provide and maintain our Service;
  
 <br></br><br></br>(b)	to notify you about changes to our Service; 
  
 <br></br><br></br>(c)	to allow you to participate in interactive features of our Service when you choose to do so; 
  
 <br></br><br></br>(d)	to provide customer support; 
  
 <br></br><br></br>(e)	to gather analysis or valuable information so that we can improve our Service; 
  
 <br></br><br></br>(f)	to monitor the usage of our Service;
  
 <br></br><br></br>(g)	to detect, prevent and address technical issues;
  
 <br></br><br></br>(h)	to fulfill any other purpose for which you provide it;
  
 <br></br><br></br>(i)	to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;
  
 <br></br><br></br>(j)	to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;
  
 <br></br><br></br>(k)	to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;
  
 <br></br><br></br>(l)	in any other way we may describe when you provide the information;
  
 <br></br><br></br>(m)	for any other purpose with your consent. 
 </p><br></br>
 <h3>6.	Retention of Data</h3>
 <p>We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
 
 <br></br><br></br>We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.
 </p><br></br>
 <h3>7.	Transfer of Data</h3>
 <p>Your information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
 
 <br></br><br></br>If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.
  
 <br></br><br></br>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
  
 <br></br><br></br>WHAT TO FABRIKAT OÜ will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
 </p><br></br>
 <h3>8.	Disclosure of Data</h3>
 <p>We may disclose personal information that we collect, or you provide:
 
 <h4>(a)	Disclosure for Law Enforcement.</h4>
 Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.
  
 <h4>(b)	Business Transaction.</h4>
 If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.
  
 <h4>(c)	Other cases. We may disclose your information also:</h4>
  
 <br></br><br></br>(i)	to our subsidiaries and affiliates;
  
 <br></br><br></br>(ii)	to contractors, service providers, and other third parties we use to support our business;
  
 <br></br><br></br>(iii)	to fulfill the purpose for which you provide it;
  
 <br></br><br></br>(iv)	for the purpose of including your company’s logo on our website;
  
 <br></br><br></br>(v)	for any other purpose disclosed by us when you provide the information;
  
 <br></br><br></br>(vi)	with your consent in any other cases;
  
 <br></br><br></br>(vii)	if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others.
 </p><br></br>
 <h3>9.	Security of Data</h3>
 <p>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p><br></br>
<h3>10.	Your Data Protection Rights Under General Data Protection Regulation (GDPR)</h3>
<p>If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data protection rights, covered by GDPR. – See more at https://eur-lex.europa.eu/eli/reg/2016/679/oj 
 
 <br></br><br></br>We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
  
 <br></br><br></br>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please email us at cofounder@lendstack.app. 
  
 <br></br><br></br>In certain circumstances, you have the following data protection rights:
  
 <br></br><br></br>(a)	the right to access, update or to delete the information we have on you;
  
 <br></br><br></br>(b)	the right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete;
  
<br></br><br></br> (c)	the right to object. You have the right to object to our processing of your Personal Data;
  
 <br></br><br></br>(d)	the right of restriction. You have the right to request that we restrict the processing of your personal information;
  
 <br></br><br></br>(e)	the right to data portability. You have the right to be provided with a copy of your Personal Data in a structured, machine-readable and commonly used format;
  
 <br></br><br></br>(f)	the right to withdraw consent. You also have the right to withdraw your consent at any time where we rely on your consent to process your personal information;
  
 <br></br><br></br>Please note that we may ask you to verify your identity before responding to such requests. Please note, we may not able to provide Service without some necessary data.
  
 <br></br><br></br>You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).
 </p><br></br>
 <h3>11.	Your Data Protection Rights under the California Privacy Protection Act (CalOPPA)</h3>
 <p>CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law’s reach stretches well beyond California to require a person or company in the United States (and conceivable the world) that operates websites collecting personally identifiable information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals with whom it is being shared, and to comply with this policy. – See more at: https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/ 
 
 <br></br><br></br>According to CalOPPA we agree to the following:
  
 <br></br><br></br>(a)	users can visit our site anonymously;
  
 <br></br><br></br>(b)	our Privacy Policy link includes the word “Privacy”, and can easily be found on the page specified above on the home page of our website;
  
 <br></br><br></br>(c)	users will be notified of any privacy policy changes on our Privacy Policy Page;
  
 <br></br><br></br>(d)	users are able to change their personal information by emailing us at cofounder@lendstack.app. 
  
 <br></br><br></br>Our Policy on “Do Not Track” Signals:
  
 <br></br><br></br>We honor Do Not Track signals and do not track, plant cookies, or use advertising when a Do Not Track browser mechanism is in place. Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked. 
  
 <br></br><br></br>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
 </p><br></br>
 <h3>12.	Service Providers</h3>
 <p>We may employ third party companies and individuals to facilitate our Service (“<b>Service Providers</b>”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.
 
 <br></br><br></br>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
 </p><br></br>
 <h3>13.	Analytics</h3>
 <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p><br></br>
 <h4>Google Analytics</h4>
 <p>Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualise and personalise the ads of its own advertising network.
 
 <br></br><br></br>For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
  
 <br></br><br></br>We also encourage you to review the Google's policy for safeguarding your data: <a href="https://support.google.com/analytics/answer/6004245">https://support.google.com/analytics/answer/6004245</a>.
 </p><br></br>
 <h4>Firebase</h4>
 <p>Firebase is analytics service provided by Google Inc.
 
 <br></br><br></br>You may opt-out of certain Firebase features through your mobile device settings, such as your device advertising settings or by following the instructions provided by Google in their Privacy Policy:<a href="https://policies.google.com/privacy?hl=en"> https://policies.google.com/privacy?hl=en</a>
  
 <br></br><br></br>For more information on what type of information Firebase collects, please visit the Google Privacy Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
 </p><br></br>
 <h4>Piwik / Matomo</h4>
 <p>Piwik or Matomo is a web analytics service. You can visit their Privacy Policy page here: <a href="https://matomo.org/privacy-policy">https://matomo.org/privacy-policy</a>
 
 </p><br></br>
 <h4>Segment.io</h4>
 <p>Segment.io is a web traffic analysis tool. You can read the Privacy Policy for Segment.io here: https://segment.com/legal/privacy/.</p><br></br>
 <h4>Cloudflare analytics</h4>
 <p>Cloudflare analytics is a web analytics service operated by Cloudflare Inc. Read the Privacy Policy here: <a href="https://www.cloudflare.com/privacypolicy/">https://www.cloudflare.com/privacypolicy/</a></p><br></br>
 <h4>Statcounter</h4>
 <p>Statcounter is a web traffic analysis tool. You can read the Privacy Policy for Statcounter here:<a href="https://statcounter.com/about/legal/"> https://statcounter.com/about/legal/</a></p><br></br>
 <h4>Flurry Analytics</h4>
 <p>Flurry Analytics service is provided by Yahoo! Inc.
 
<br></br><br></br> You can opt-out from Flurry Analytics service to prevent Flurry Analytics from using and sharing your information by visiting the Flurry's Opt-out page: <a href="https://dev.flurry.com/secure/optOut.do">https://dev.flurry.com/secure/optOut.do</a>
  
<br></br><br></br> For more information on the privacy practices and policies of Yahoo!, please visit their Privacy Policy page: <a href="https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm">https://policies.yahoo.com/us/en/yahoo/privacy/policy/index.htm</a>
 </p><br></br>
 <h4>Unity Analytics</h4>
 <p>Unity Analytics is provided by Unity Technologies.
 
 <br></br><br></br>For more information on what type of information Unity Analytics collects, please visit their Privacy Policy page: <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>
 </p><br></br>
 <h3>14.	CI/CD tools</h3>
 <p>We may use third-party Service Providers to automate the development process of our Service.</p><br></br>
 <h4>GitHub</h4>
 <p>GitHub is provided by GitHub, Inc.
 
 <br></br><br></br>GitHub is a development platform to host and review code, manage projects, and build software.
  
 <br></br><br></br>For more information on what data GitHub collects for what purpose and how the protection of the data is ensured, please visit GitHub Privacy Policy page: <a href="https://help.github.com/en/articles/github-privacy-statement">https://help.github.com/en/articles/github-privacy-statement</a>.
 </p><br></br>
 <h4>GitLab CI/CD</h4>
 <p>GitLab CI/CD is provided by GitLab, Inc.
 
 <br></br><br></br>GitLab CI (Continuous Integration) service is a part of GitLab that build and test the software whenever developer pushes code to application. 
  
 <br></br><br></br>GitLab CD (Continuous Deployment) is a software service that places the changes of every code in the production which results in every day deployment of production. 
 <br></br><br></br>For more information on what data GitLab CI/CD collects for what purpose and how the protection of the data is ensured, please visit GitLab CI/CD Privacy Policy page: <a href="https://about.gitlab.com/privacy/">https://about.gitlab.com/privacy/</a>. 
 </p><br></br>
 <h4>Fastlane</h4>
 <p>Fastlane is provided by Google, Inc.
 <br></br><br></br>Fastlane is a continuous delivery tool for iOS and Android apps. 
 
 <br></br><br></br>For more information on what data Fastlane collects for what purpose and how the protection of the data is ensured, please visit the Google Privacy Policy page: <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>. 
  
 </p><br></br>
 <h4>Codecov</h4>
 <p>Codecov provides highly integrated tools to group, merge, archive and compare coverage reports. 
 
 <br></br><br></br>For more information on what data Codecov collects for what purpose and how the protection of the data is ensured, please visit their Privacy Policy page:<a href="https://codecov.io/privacy"> https://codecov.io/privacy</a>. 
 </p><br></br>
 <h4>Codemagic</h4>
 <p>Codemagic is provided by Nevercode LTD.
 
 <br></br><br></br>Codemagic is the official CI/CD solution dedicated just for Flutter apps.
  
 <br></br><br></br>For more information on what data Codemagic collects for what purpose and how the protection of the data is ensured, please visit their Terms and conditions page: <a href="https://codemagic.io/terms/">https://codemagic.io/terms/</a>.
 </p><br></br>
 <h3>15.	Advertising</h3>
 <p>We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.</p><br></br>
 <h4>Google AdSense DoubleClick Cookie</h4>
 <p>Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet.
 
 <br></br><br></br>You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: http://www.google.com/ads/preferences/
 </p><br></br>
 <h4>Bing Ads</h4>
 <p>Bing Ads is an advertising service provided by Microsoft Inc.
 
 <br></br><br></br>You can opt-out from Bing Ads by following the instructions on Bing Ads Opt-out page: https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
  
 <br></br><br></br>For more information about Bing Ads, please visit their Privacy Policy: https://privacy.microsoft.com/en-us/PrivacyStatement
 </p><br></br>
 <h4>AdMob by Google</h4>
 <p>AdMob by Google is provided by Google Inc.
 
<br></br><br></br> You can opt-out from the AdMob by Google service by following the instructions described by Google: https://support.google.com/ads/answer/2662922?hl=en
  
 <br></br><br></br>For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners' sites or app” page: http://www.google.com/policies/privacy/partners/ or visit the Privacy Policy of Google: http://www.google.com/policies/privacy/
 </p><br></br>
 <h4>AdButler</h4>
 <p>AdButler is an advertising service provided by Sparklit Networks Inc.
For more information about AdButler, please visit their Privacy Policy: https://www.sparklit.com/agreements.spark?agreement=privacy
</p><br></br>
<h4>Unity Ads</h4>
<p>Unity Ads is provided by Unity Technologies.
 
<br></br><br></br> You can opt-out from Unity Ads service by following the instructions as described by Unity Technologies on their Privacy Policy page: https://unity3d.com/legal/privacy-policy
  
 <br></br><br></br>For more information about Unity Technologies, please visit Unity Technologies Privacy Policy: https://unity3d.com/legal/privacy-policy
 </p><br></br>
 <h4>16.	Behavioral Remarketing</h4>
 <p>WHAT TO FABRIKAT OÜ uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.</p><br></br>
            <h4>Google Ads (AdWords)</h4>
            <p>Google Ads (AdWords) remarketing service is provided by Google Inc.
 
 <br></br><br></br>You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: http://www.google.com/settings/ads
  
 <br></br><br></br>Google also recommends installing the Google Analytics Opt-out Browser Add-on – https://tools.google.com/dlpage/gaoptout – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.
  
 <br></br><br></br>For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: https://policies.google.com/privacy?hl=en
 </p><br></br>
 <h4>Bing Ads Remarketing</h4>
 <p>Bing Ads remarketing service is provided by Microsoft Inc.
 
 <br></br><br></br>You can opt-out of Bing Ads interest-based ads by following their instructions: https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
  
 <br></br><br></br>You can learn more about the privacy practices and policies of Microsoft by visiting their Privacy Policy page: https://privacy.microsoft.com/en-us/PrivacyStatement
 </p><br></br>
 <h4>Twitter</h4>
 <p>Twitter remarketing service is provided by Twitter Inc.
 
 <br></br><br></br>You can opt-out from Twitter's interest-based ads by following their instructions: https://support.twitter.com/articles/20170405
  
 <br></br><br></br>You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy page: https://twitter.com/privacy
 </p><br></br>
 <h4>Facebook</h4>
 <p>Facebook remarketing service is provided by Facebook Inc.
 
 <br></br><br></br>You can learn more about interest-based advertising from Facebook by visiting this page: https://www.facebook.com/help/164968693837950
  
 <br></br><br></br>To opt-out from Facebook's interest-based ads, follow these instructions from Facebook: https://www.facebook.com/help/568137493302217
  
 <br></br><br></br>Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your mobile device settings.
  
 <br></br><br></br>For more information on the privacy practices of Facebook, please visit Facebook's Data Policy: https://www.facebook.com/privacy/explanation
 </p><br></br>
 <h4>Pinterest</h4>
 <p>Pinterest remarketing service is provided by Pinterest Inc.
 
 <br></br><br></br>You can opt-out from Pinterest's interest-based ads by enabling the “Do Not Track” functionality of your web browser or by following Pinterest instructions: http://help.pinterest.com/en/articles/personalization-and-data
  
 <br></br><br></br>You can learn more about the privacy practices and policies of Pinterest by visiting their Privacy Policy page: https://about.pinterest.com/en/privacy-policy
  
 </p><br></br>
 <h3>17.	Payments</h3>
 <p>We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).
 
 <br></br><br></br> We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
  
 <br></br><br></br>The payment processors we work with are:
 </p><br></br>
 <h4>PayPal or Braintree:</h4>
 <p>Their Privacy Policy can be viewed at https://www.paypal.com/webapps/mpp/ua/privacy-full</p><br></br>
 <h4>Apple Store In-App Payments:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.apple.com/legal/privacy/en-ww/ / https://support.apple.com/en-us/HT203027 </p><br></br>
 <h4>Google Play In-App Payments:</h4>
 <p>Their Privacy Policy can be viewed at: https://policies.google.com/privacy?hl=en&gl=us / https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en </p><br></br>
 <h4>Stripe:</h4>
 <p>Their Privacy Policy can be viewed at: https://stripe.com/us/privacy</p><br></br>
 <h4>Instamojo:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.instamojo.com/privacy// </p><br></br>
 <h4>Razorpay:</h4>
 <p>Their Privacy Policy can be viewed at: https://razorpay.com/privacy/</p><br></br>
 <h4>Payoneer:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.payoneer.com/in/legal/privacy-policy/ </p><br></br>
 <h4>CashFree:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.cashfree.com/privacypolicy.html</p><br></br>
 <h4>Klarna:</h4>
 <p>Their Services Terms, Privacy Policy and Buyer Protection Policy can be viewed at https://www.klarna.com/us/legal/.</p><br></br>
 <h4>Moneris:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.moneris.com/legal/privacy-</p><br></br>
 <h4>PayU:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.payu.in/privacy-policy</p><br></br>
 <h4>Paytm:</h4>
 <p>Their Privacy Policy can be viewed at: https://pages.paytm.com/privacy.html</p><br></br>
 <h4>WeChat:</h4>
 <p>Their Privacy Policy can be viewed at: https://www.wechat.com/en/privacy_policy.html </p><br></br>
 <h3>18.	Links to Other Sites</h3>
 <p>Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
 
 <br></br><br></br>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
 </p><br></br>
 <h3>19.	Children's Privacy</h3>
 <p>Our Services are not intended for use by children under the age of 18 (“<b>Child</b>” or “<b>Children</b>”). 
 
 <br></br><br></br>We do not knowingly collect personally identifiable information from Children under 18. If you become aware that a Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from Children without verification of parental consent, we take steps to remove that information from our servers.
 </p><br></br>
 <h3>20.	Changes to This Privacy Policy</h3>
 <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
 
 <br></br><br></br>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.
  
 <br></br><br></br>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
 <br></br><br></br>The Privacy Policy was last updated on 24/01/2024
 </p><br></br>
 <h3>21.	Contact Us</h3>
 <p>If you have any questions about this Privacy Policy, please contact us:
 
 <br></br>By email: cofounder@lendstack.app.
  
 <br></br>By visiting this page on our website: https://lendstack.app/#/contact.
  
 <br></br>By phone number: +91-9923055180.
 </p><br></br>
             </div>
    );
  }
}
export default withRouter(PrivacyPolicy);
